import { render, staticRenderFns } from "./DnBox.vue?vue&type=template&id=4edcbde4&scoped=true&"
import script from "./DnBox.vue?vue&type=script&lang=js&"
export * from "./DnBox.vue?vue&type=script&lang=js&"
import style0 from "./DnBox.vue?vue&type=style&index=0&id=4edcbde4&lang=scss&scoped=true&"
import style1 from "./DnBox.vue?vue&type=style&index=1&id=4edcbde4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edcbde4",
  null
  
)

export default component.exports